import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import { formatSegmentationNetSalesValue, formatSegmentationValue } from "../../utils/segmentation-utils";

export const segmentationFormConfig = ({ segmentation } = {}) => {
	return [
		{
			fields: [
				{
					name: "segmentation",
					label: "Tamanho do cliente *",
					type: "text",
					placeholder: "Ex: P, M, G...",
					defaultValue: segmentation?.segmentation || "",
					columns: 12,
					maxLength: 2,
					onChange: formatSegmentationValue
				},
				{
					name: "netSalesGreaterOrEqual",
					label: "Net Sales maior ou igual à *",
					type: "text",
					placeholder: "R$ 0,00",
					defaultValue:
						segmentation?.netSalesGreaterThanOrEqual !== undefined &&
						segmentation?.netSalesGreaterThanOrEqual !== null
							? MonetaryUtils.formatCurrency(segmentation.netSalesGreaterThanOrEqual)
							: "",
					columns: 12,
					onChange: formatSegmentationNetSalesValue
				}
			]
		}
	];
};